interface CyprusDivingSpecialProps {
  className?: string;
}

const features = [
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <line x1="12" y1="8" x2="12" y2="12" />
        <line x1="12" y1="16" x2="12.01" y2="16" />
      </svg>
    ),
    title: 'Independent',
    body: 'No dive centre affiliations or paid placements — everything is presented objectively.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 12a9 9 0 1 0 18 0 9 9 0 0 0-18 0" />
        <path d="M12 8v4l3 3" />
        <path d="M7.5 4.5C9 3.5 10.5 3 12 3" />
      </svg>
    ),
    title: 'Real Dive Insights',
    body: 'Site notes and conditions are based on actual dives, not recycled descriptions.',
  },
  {
    icon: (
      <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
        <path d="M7 11V7a5 5 0 0 1 10 0v4" />
      </svg>
    ),
    title: 'No Sponsored Listings',
    body: 'Nothing is ranked or promoted for payment — listings are neutral and informational.',
  },
];

const CyprusDivingSpecial = ({ className = '' }: CyprusDivingSpecialProps) => {
  return (
    <section
      className={`py-14 sm:py-18 md:py-24 ${className}`}
      style={{
        background: '#0B1622',
        borderTop: '1px solid rgba(255,255,255,0.06)',
      }}
    >
      <div className="container mx-auto px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">

          {/* Headline */}
          <div className="text-center mb-4">
            <h2
              className="text-3xl sm:text-4xl md:text-5xl font-headline font-bold mb-3"
              style={{ color: '#EAF4F8' }}
            >
              About This Guide
            </h2>
            <div className="w-12 h-0.5 mx-auto mb-5" style={{ background: '#6FD3E0' }} />
            {/* Short intro line */}
            <p
              className="text-base sm:text-lg md:text-xl max-w-2xl mx-auto"
              style={{ color: '#A9C3CF', fontWeight: 400 }}
            >
              Cyprus Diving is an <strong style={{ color: '#EAF4F8' }}>independent guide</strong> built for divers who want clarity before they get in the water.
            </p>
          </div>

          {/* 3 Feature Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-5 sm:gap-6 mt-10 mb-10">
            {features.map((feature) => (
              <div
                key={feature.title}
                className="rounded-2xl p-6 sm:p-7 flex flex-col gap-4"
                style={{
                  background: '#0F2234',
                  border: '1px solid rgba(111,211,224,0.22)',
                  boxShadow: '0 0 18px rgba(111,211,224,0.06)',
                }}
              >
                {/* Icon */}
                <div
                  className="w-11 h-11 rounded-xl flex items-center justify-center flex-shrink-0"
                  style={{
                    background: 'rgba(255,138,61,0.12)',
                    color: '#FF8A3D',
                  }}
                >
                  {feature.icon}
                </div>
                {/* Title */}
                <h3
                  className="text-base sm:text-lg font-semibold"
                  style={{ color: '#EAF4F8' }}
                >
                  {feature.title}
                </h3>
                {/* Body */}
                <p
                  className="text-sm sm:text-base leading-relaxed"
                  style={{ color: '#A9C3CF' }}
                >
                  {feature.body}
                </p>
              </div>
            ))}
          </div>

          {/* Supporting paragraph */}
          <p
            className="text-sm sm:text-base md:text-lg leading-relaxed text-center max-w-2xl mx-auto mb-4"
            style={{ color: '#A9C3CF' }}
          >
            No sponsored listings. No paid placements. Just practical, experience-based information you can actually use.
          </p>
          <p
            className="text-sm sm:text-base md:text-lg leading-relaxed text-center max-w-2xl mx-auto mb-6"
            style={{ color: '#A9C3CF' }}
          >
            From detailed dive site breakdowns to real conditions and planning insights, everything here is designed to help you choose better dives — whether it&apos;s your first or your hundredth.
          </p>

          {/* Bullets */}
          <ul className="max-w-xl mx-auto mb-8 space-y-2">
            {[
              'Detailed dive site breakdowns',
              'Real conditions and planning insights',
              'No marketing fluff — just useful diving information',
            ].map((item) => (
              <li key={item} className="flex items-start gap-3">
                <span className="mt-1.5 w-1.5 h-1.5 rounded-full flex-shrink-0" style={{ background: '#6FD3E0' }} />
                <span className="text-sm sm:text-base" style={{ color: '#A9C3CF' }}>{item}</span>
              </li>
            ))}
          </ul>

          {/* Closing statement */}
          <p
            className="text-center text-base sm:text-lg font-semibold"
            style={{ color: '#6FD3E0' }}
          >
            No commissions. No sponsored listings. Just clear, practical diving guidance.
          </p>

        </div>
      </div>
    </section>
  );
};

export default CyprusDivingSpecial;